import some from 'lodash/some';
import template from './dashboardByGroupPart.component.html';

function DashboardByGroupsCtrl($state) {
  'ngInject';

  const vm = this;

  vm.$onInit = () => {
    if ($state.current.name === 'dashboard' && some(vm.part.dashboards, { id: $state.params.id })) {
      expand();
    }
    if (vm.level === 0) {
      expand();
    }
  };
  vm.collapse = toggle;
  vm.expand = expand;
  vm.isCollapseAllowed = isCollapseAllowed;
  vm.size = _.size;

  function isCollapseAllowed() {
    return !vm.search && vm.level > 0;
  }

  function toggle() {
    if (isCollapseAllowed()) {
      vm.part.isExpanded = !vm.part.isExpanded;
    }
  }

  function expand() {
    vm.part.isExpanded = true;
    vm.expandparent?.();
  }
}

export default {
  name: 'dashboardByGroupPart',
  template,
  bindings: {
    expandparent: '<?',
    part: '=',
    search: '<',
    level: '<'
  },
  controller: DashboardByGroupsCtrl
};
